import React, { Component } from 'react';
import classNames from 'classnames';
import Tippy from '@tippyjs/react';
import { ReactComponent as InfoIconSvg } from '../../../../../../../includes/assets/icons/info-circle-solid.svg';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import 'tippy.js/animations/scale.css';

export default class InfoIcon extends Component {
	render() {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
		});
		return (
			<Tippy
				content={this.props.infoText}
				interactive={this.props.interactive}
				animation={true}
			>
				<div className={mainClasses}>
					<InfoIconSvg />
				</div>
			</Tippy>
		);
	}
}
